var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"industry-norms"},[_c('div',{directives:[{name:"lazy",rawName:"v-lazy:background-image",value:({
      src: require('../aiImg/ing_bj_bs@2x.png'),
      loading: require('../aiImg/ing_bj_bs@2x.png'),
    }),expression:"{\n      src: require('../aiImg/ing_bj_bs@2x.png'),\n      loading: require('../aiImg/ing_bj_bs@2x.png'),\n    }",arg:"background-image"}],staticClass:"banner"})])
}
var staticRenderFns = []

export { render, staticRenderFns }